module.exports = __webpack_public_path__ + "static/media/facebook.7de042fb.png";